<template>
	<v-col class="reward">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Testimoni</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-format-float-left</v-icon>
			<div class="pl-2">Testimoni</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-row>
							<v-col cols="12" class="px-5 pt-5">
								<div class="font-size-14 cl-primary">Form Testimoni</div>
								<div class="pt-3">
									<v-textarea label="Testimoni Anda" color="primary" rows="5" no-resize hide-details="auto" v-model="testimony"></v-textarea>
								</div>
							</v-col>
						</v-row>
						<v-row justify="end">
							<v-col cols="6" sm="4" class="px-5 pb-5 text-right">
								<v-btn large width="120" depressed class="bg-primary white--text rounded-lg" :disabled="!testimony" :loading="btnLoading" @click="proccessTestimony">
									<v-icon>mdi-arrow-right-bold-circle</v-icon>
									<span class="pl-2">Kirim</span>
								</v-btn>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			testimony: '',
			btnLoading: false,
		}
	},
	computed: {
		...mapState('testimony', ['responseSuccess']),
	},
	methods: {
		...mapActions('testimony', ['addTestimony']),

		proccessTestimony() {
			this.btnLoading = true
			this.addTestimony({testimony: this.testimony}).then(() => {
				this.btnLoading = false
				this.testimony = ''
			})
		}
	},
	created(){
		this.$store.dispatch('setPageTitle', `Testimoni`)
	}
};
</script>